import React, { useCallback, useEffect, useState } from 'react';
import { Col, Layout, PageHeader, Row, Tabs } from 'antd';
import { useHistory, useParams } from 'react-router';
import { UserGroup } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { UserGroupDetailsForm } from './user-group-details-form';
import { UserGroupRolesForm } from './user-group-roles-form';
import { UserGroupMembersForm } from './user-group-members-form';
import { UserGroupPermissionsPage } from './user-group-permissions-page';

export function UserGroupPage() {
  const history = useHistory();
  const { id } = useParams() as any;
  const [userGroup, setUserGroup] = useState<UserGroup>();

  const { Content } = Layout;

  const onBackClick = () => {
    history.goBack();
  };

  const loadUserGroup = useCallback(() => {
    apiClient
      .get(`user-groups/${id}`)
      .then((response: any) => {
        setUserGroup(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, [id]);

  const onUserGroupChanged = () => {
    loadUserGroup();
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    loadUserGroup();
  }, [id, loadUserGroup]);

  const TabContent = (props: any) => {
    return <Content style={{ backgroundColor: '#fff' }}>{props.children}</Content>;
  };

  return (
    <>
      <PageHeader title="Kullanıcı grubu düzenle" subTitle={userGroup?.name} onBack={onBackClick} />
      <Content>
        <Tabs>
          <Tabs.TabPane tab="Detaylar" key="details">
            <TabContent>
              <Row>
                <Col span={8} xs={24} sm={24} md={12} lg={10} xl={10} xxl={8}>
                  <UserGroupDetailsForm userGroup={userGroup} onSaved={onUserGroupChanged} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Kullanıcılar" key="users">
            <TabContent>
              <Row>
                <Col span={16} xs={24} sm={24} md={24} lg={20} xl={20} xxl={16}>
                  <UserGroupMembersForm userGroup={userGroup} />
                </Col>
              </Row>
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Roller (yeni)" key="roles">
            <TabContent>
              <UserGroupRolesForm userGroup={userGroup} />
            </TabContent>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Yetkiler (yeni)" key="permissions">
            <TabContent>
              <UserGroupPermissionsPage userGroup={userGroup} />
            </TabContent>
          </Tabs.TabPane>
        </Tabs>
      </Content>
    </>
  );
}
